import { axios } from '../util/axios'
import platform from '../util/platform'

const API_V3_ENDPOINT = path => `/reactivate/v3/${path}`

export const reactivateAccountStrongPassword = (token, password) => {
  return axios
    .post(API_V3_ENDPOINT('change-password'), { token, password, platform })
    .then(response => response.data)
}
